/* eslint-disable import/prefer-default-export */
import axios from '../axios';

// ---------------------------------------------------------------------------
// Financeiro / Contas bancárias — Service Layer (handoff 0079)
//
// Camada fina sobre o axios singleton. Desembrulha o envelope JSend no sucesso
// (`data.data`) e propaga o erro cru — o tratamento (dicionário de `code`,
// fieldErrors) fica nas páginas via `pages/Finance/utils/apiError.js`, padrão
// vigente enquanto a infra FC1/FC4 não está ligada.
//
// A tradução camelCase (args) → snake_case (backend) acontece SÓ aqui. Os
// campos das linhas ficam em snake_case, preservando simetria com a API.
//
// Contexto: a chave da ASAAS saiu do .env e virou cadastro. Esta camada trata
// da CONTA (o "quem recebe"); a credencial (o segredo) vive em
// integrationCredentialsApi.js.
// ---------------------------------------------------------------------------

// Lista completa — o backend NÃO pagina nesta fase (volume de unidades).
// `status` (active|inactive) e `search` (apelido, titular ou documento) são
// opcionais; só os não-vazios viram query param.
export async function listBankAccounts(filters = {}) {
   const { status, search } = filters;

   const params = {};
   if (status) params.status = status;
   if (search) params.search = search;

   const response = await axios.get('/finance/bank-accounts', { params });
   return response?.data?.data?.bank_accounts ?? [];
}

export async function getBankAccount(bankAccountId) {
   const response = await axios.get(`/finance/bank-accounts/${bankAccountId}`);
   return response?.data?.data?.bank_account ?? null;
}

// O documento pode ir formatado: o backend valida o dígito verificador e
// normaliza para só dígitos na resposta.
export async function createBankAccount(payload) {
   const response = await axios.post('/finance/bank-accounts', payload);
   return {
      bankAccount: response?.data?.data?.bank_account ?? null,
      message: response?.data?.message ?? 'Conta bancária criada com sucesso.',
   };
}

// PUT com atualização parcial (todos os campos opcionais). `status` NÃO entra
// aqui — tem endpoint próprio (setBankAccountStatus).
export async function updateBankAccount(bankAccountId, payload) {
   const response = await axios.put(
      `/finance/bank-accounts/${bankAccountId}`,
      payload,
   );
   return {
      bankAccount: response?.data?.data?.bank_account ?? null,
      message:
         response?.data?.message ?? 'Conta bancária atualizada com sucesso.',
   };
}

// Não existe DELETE: conta se desativa (há credenciais e cobranças apontando
// para ela). Mudar para o status que já vigora devolve 422
// `bank_account_status_unchanged` — a página trata como aviso, não erro grave.
export async function setBankAccountStatus(bankAccountId, status) {
   const response = await axios.patch(
      `/finance/bank-accounts/${bankAccountId}/status`,
      { status },
   );
   return {
      bankAccount: response?.data?.data?.bank_account ?? null,
      message: response?.data?.message ?? 'Situação da conta atualizada.',
   };
}
